module.exports = __webpack_public_path__ + "img/barFilledLarge.aba316c7.svg";